
<template>
  <!--商品分组-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="groupId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_" slot-scope="{row}">
        <span>{{}}</span>
      </template>
    </x-tabula>

    <!--新增分组的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @cancel="visible=false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      width="700px"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'goodsGroup',
  data () {
    return {
      modalTitle: '新增分组',
      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          label: '分组名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入分组名称',
          props: ['name', {
            rules: [{required: true, message: '请输入分组名称'}]
          }]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入排序',
          props: ['sort', {
            rules: [
              {required: true, message: '请输入排序'},
              { pattern: /^\d*$/, message: '请输入数字' },
              { max: 4, message: '不超过4位' }
            ]
          }]
        }
      ],
      formKey: {
        name: undefined,
        sort: undefined
      },
      addParam: {
        url: '/pm/group',
        reqHandle: '', // addParam、editParaM都会执行 reqHandle方法
        resHandle: this.resHandle
      },
      editParam: {
        url: '/pm/group/',
        resHandle: this.resHandle
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      },

      searchList: [
        { props: ['name'], placeholder: '名称', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:goodsGroup:add'] }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: row => this.editHandle(row),
          permi: ['community:goodsGroup:edit']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          rowOptDisHandle: row => false,
          permi: ['community:goodsGroup:delete']
        }
      ],
      columns: [
        { title: '分组名称', dataIndex: 'name', align: '', width: '' },
        { title: '商品数量', dataIndex: 'productCount', align: '', width: '' },
        { title: '排序', dataIndex: 'sort', align: '', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: '', width: '' },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [
        { name: '分组1' }
      ],
      searchParams: {
        name: undefined
      },
      listApi: {
        url: '/pm/group/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '/pm/group/',
        title: '分组',
        key: 'name',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
    },
    /** 新增分组 */
    openModal () {
      this.modalTitle = '新增分组';
      this.visible = true;
    },
    editHandle (row) {
      this.modalTitle = '编辑分组';
      this.visible = true;
      this.$nextTick(() => {
        const { name, sort } = row;
        this.$refs.addEdit.form.setFieldsValue({ name, sort });
        this.$refs.addEdit.routeQuery = row.groupId;
      });
    },
    resHandle (res) {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
